import { DASHBOARD_ROUTES } from "./dashboardRoutes";
import { EXAM_COURSE_ROUTES } from "./courses/examCourseRoutes";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import HomeDashboardLayout from "../homeDashboard/HomeDashboardLayout";
import "../dashboard/Dashboard.css";
import "./HomeDashboard.css";
import "./DashboardFavoriteExam.css";
import "./DashboardSkeleton.css";
import MyWalletSidebar from "./MyWalletSidebar";
import SliderCard from "../dashboard/SliderCard";
import MyExamSlider from "../exams/MyExamSlider";
import LogoIcon from "../assets/images/SliderLogo.png";
import examImg from "../assets/images/state-img.png";
import starIcon from "../assets/images/bookmark.png";
import { ExamCardSVG } from "../components/SvgIcons";
import { useExamCategories } from "../hooks/useExamCategories";

const sliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  pauseOnHover: true,
  arrows: true,
  swipeToSlide: false,
  focusOnSelect: true,
  touchMove: true,
  touchThreshold: 15,
  responsive: [
    { breakpoint: 1920, settings: { slidesToShow: 4 } },
    { breakpoint: 1600, settings: { slidesToShow: 4 } },
    { breakpoint: 1400, settings: { slidesToShow: 3 } },
    { breakpoint: 1200, settings: { slidesToShow: 4 } },
    { breakpoint: 900, settings: { slidesToShow: 3 } },
    { breakpoint: 767, settings: { slidesToShow: 2} },
    { breakpoint: 576, settings: { slidesToShow: 2 } },
    { breakpoint: 400, settings: { slidesToShow: 1} },
    { breakpoint: 320, settings: { slidesToShow: 1 } },
  ],
};

function FavoriteExamShimmer() {
  const renderExamCards = (count, className = "") => (
    <div className={`favorite-exam-shimmer__cards ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="favorite-exam-shimmer__exam dashboard-skeleton">
          <span className="favorite-exam-shimmer__badge dashboard-skeleton" />
          <span className="favorite-exam-shimmer__title dashboard-skeleton" />
          <span className="favorite-exam-shimmer__text dashboard-skeleton" />
        </div>
      ))}
    </div>
  );

  return (
    <div className="favorite-exam-shimmer" aria-label="Loading favorite exams">
      <section className="favorite-exam-shimmer__section">
        <span className="favorite-exam-shimmer__heading dashboard-skeleton" />
        {renderExamCards(4, "favorite-exam-shimmer__cards--exams")}
      </section>
      <section className="favorite-exam-shimmer__section">
        <span className="favorite-exam-shimmer__heading dashboard-skeleton" />
        {renderExamCards(4, "favorite-exam-shimmer__cards--exams")}
      </section>
      <section className="favorite-exam-shimmer__section">
        <span className="favorite-exam-shimmer__heading dashboard-skeleton" />
        {renderExamCards(4, "favorite-exam-shimmer__cards--categories")}
      </section>
    </div>
  );
}

function mapExamToSliderItem(exam) {
  return {
    id: exam?.md_exams_id,
    name: exam?.exam_name || "Exam",
    location: exam?.state_name || "",
    image: exam?.exam_image || examImg,
    icon: LogoIcon,
    staricon: starIcon,
    isStarred: Number(exam?.is_favourite) === 1,
    isSelected: Number(exam?.is_user_exam) === 1 || Number(exam?.is_subscribed) === 1,
  };
}

const SliderSection = ({ title, items = [], emptyMessage, children }) => {
  const navigate = useNavigate();
  const openMasterExam = (item) => navigate(EXAM_COURSE_ROUTES.plans, {
    state: { md_exam_id: Number(item?.id || 0), selectedMasterExam: item },
  });

  return (
    <Row className="g-4 align-items-start dashboard-states mt-0">
      <Col md={12} xl={12}>
        <div className="d-flex align-items-center myexams-qb-header border-bottom-0">
          <div className="myexams-qb-left">
            <span className="myexams-qb-icon text-purple" aria-hidden="true">
              <i className="fa fa-graduation-cap"></i>
            </span>
            <span className="myexams-qb-title fw-semibold blackText">{title}</span>
          </div>
          <div className="myexams-qb-divider" aria-hidden="true"></div>
          {children}
        </div>

        {items.length ? (
          <MyExamSlider
            items={items}
            renderItem={(item) => <SliderCard item={item} onClick={() => openMasterExam(item)} />}
            settings={sliderSettings}
          />
        ) : (
          <p className="choose-state__status">{emptyMessage}</p>
        )}
      </Col>
    </Row>
  );
};

const FavoriteExam = () => {
  const navigate = useNavigate();
  const {
    data: examCategoriesData,
    isLoading,
    isFetching,
    isPlaceholderData,
    isError,
    error,
  } = useExamCategories();

  const hasExamData = [
    examCategoriesData?.favoriteExams,
    examCategoriesData?.myStateExams,
    examCategoriesData?.otherExams,
    examCategoriesData?.categories,
  ].some((items) => Array.isArray(items) && items.length > 0);
  const showLoadingShimmer = isLoading || (!hasExamData && (isFetching || isPlaceholderData));

  const loadError = isError
    ? error?.response?.data?.message || error?.message || "Unable to load exams."
    : "";

  const enrolledExams = (examCategoriesData?.favoriteExams || []).map(mapExamToSliderItem);
  const popularExams = (examCategoriesData?.myStateExams || []).map(mapExamToSliderItem);
  const suggestedExams = (examCategoriesData?.otherExams || []).map(mapExamToSliderItem);
  const exploreCategories = examCategoriesData?.categories || [];
  const openMasterExam = (item) => navigate(EXAM_COURSE_ROUTES.plans, {
    state: { md_exam_id: Number(item?.id || 0), selectedMasterExam: item },
  });

  return (
     <>
  <style>{`
    .slick-track {
       margin-left: 0;
     }
    .exam-card {
       border-radius: 0;
     }
  `}</style>
    <HomeDashboardLayout showHeader={false}>
      <div className="innerContent dashboardExam">
        <div className="battle myexams-block">
          {showLoadingShimmer ? <FavoriteExamShimmer /> : null}
          {!showLoadingShimmer && loadError ? <p className="choose-state__status choose-state__status--error">{loadError}</p> : null}

          {!showLoadingShimmer && !loadError ? (
            <>
              <Row className="g-3 dashboard-states">
                <Col md={12} xl={12}>
                  <div className="d-flex align-items-center myexams-qb-header border-bottom-0">
                    <div className="myexams-qb-left">
                      <span className="myexams-qb-icon text-purple" aria-hidden="true">
                        <i className="fa fa-graduation-cap"></i>
                      </span>
                      <span className="myexams-qb-title fw-semibold blackText">Your Enrolled Exams</span>
                    </div>
                    <div className="myexams-qb-divider" aria-hidden="true"></div>
                    <Link to={DASHBOARD_ROUTES.examCategories} className="myexams-qb-action text-purple text-decoration-none">
                      <span className="myexams-qb-plus">
                        <i className="fas fa-plus"></i>
                      </span>
                      Add Exam
                    </Link>
                  </div>
                </Col>

                {enrolledExams.length ? (
                  <div className="enroll-Row">
                    {enrolledExams.map((item) => (
                      <div key={item.id}>
                        <SliderCard item={item} onClick={() => openMasterExam(item)} />
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="choose-state__status">No enrolled exams available.</p>
                )}
              </Row>

              <SliderSection
                title="Popular Exams"
                items={popularExams}
                emptyMessage="No popular exams available."
              />

              <SliderSection
                title="Suggested Exam"
                items={suggestedExams}
                emptyMessage="No suggested exams available."
              />

              <div className="row g-4 examCard-section">
                <Col md={12} xl={12}>
                  <div className="d-flex align-items-center myexams-qb-header border-bottom-0 pb-0">
                    <div className="myexams-qb-left">
                      <span className="myexams-qb-icon text-purple" aria-hidden="true">
                        <i className="fa fa-graduation-cap"></i>
                      </span>
                      <span className="myexams-qb-title fw-semibold blackText">Explore More Exam</span>
                    </div>
                    <div className="myexams-qb-divider" aria-hidden="true"></div>
                  </div>
                </Col>

                {exploreCategories.length ? (
                  exploreCategories.map((item) => (
                    <div className="col-md-6" key={item.category_id}>
                      <Link to="/selected-exam" className="text-decoration-none">
                        <div className="exam-card d-flex align-items-center position-relative">
                          <div>
                            <ExamCardSVG />
                          </div>

                          <div className="examContent d-flex align-items-center justify-content-between w-100 position-relative">
                            <div className="d-flex align-items-center gap-3">
                              <img src={item.icon_url || item.image_url || examImg} alt={item.name} className="exam-img" />
                              <div>
                                <h6 className="exam-title mb-0 fw-semibold">{item.name}</h6>
                                <p className="exam-subtitle mb-0">
                                  <span className="fw-medium exam-count">
                                    {Number(item.exam_count || 0)} Exam
                                    {Number(item.exam_count || 0) === 1 ? "" : "s"}
                                  </span>
                                  <span className="fw-normal exam-selected ms-1">
                                    ({Number(item.favorite_count || 0)} favorites)
                                  </span>
                                </p>
                              </div>
                            </div>

                            <span className="chevron-btn">
                              <i className="bi bi-chevron-right"></i>
                            </span>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <div className="col-md-12">
                    <p className="choose-state__status">No exam categories available.</p>
                  </div>
                )}
              </div>
            </>
          ) : null}
        </div>
      </div>

      <MyWalletSidebar />
    </HomeDashboardLayout>
    </>
  );
};

export default FavoriteExam;
